import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ContactInfoModal from "../ContactInfoModal/ContactInfoModal";
import PhoneIcon from "../icons/PhoneIcon";

type FacilitatorCellProps = {
  facilitator: {
    id: string;
    first_name: string;
    last_name: string;
  } | null | undefined;
};

export default function FacilitatorCell({ facilitator }: FacilitatorCellProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  if (!facilitator) {
    return <span>—</span>;
  }

  const fullName = `${facilitator.first_name ?? ""} ${facilitator.last_name ?? ""}`.trim();

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
      {fullName}
      <button
        type="button"
        className="contact-icon-btn"
        title={t("pages.entrevistas.requestContactTooltip")}
        onClick={() => setIsOpen(true)}
      >
        <PhoneIcon />
      </button>
      <ContactInfoModal
        userId={facilitator.id}
        userName={fullName}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </span>
  );
}

